import type { FaireProductEntity } from "../../entity_types/product";

export const p_374t899zgp: FaireProductEntity = {
  token: "p_374t899zgp",
  type: "product",
  name: "6x2mm Natural  Rondelle beads For Jewelry Making RET26-15-13",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/3a738511d4ce44ef672ae4b53264a32967a6a985980e5a5335c22909c052491f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/93824f4037478980c84d3ca8c9486ad7a5eaebaa17b5a266c841eae341052715.jpeg",
    "https://cdn.faire.com/fastly/eba2532e1be016acdb00ce894f39e7f21e037fd60db2e39bae42244c8c828e19.jpeg",
    "https://cdn.faire.com/fastly/3d5826a9c125f76b3bd46caebd7c1a023060e259222e7b51c20bf392b598e426.jpeg",
    "https://cdn.faire.com/fastly/7862ddd2a69f4d2efbb5e169cd5443a9eb28db6c9b93400b12dd5391470fb1e7.jpeg",
    "https://cdn.faire.com/fastly/c2e8626693f1200df0f0f0ea75356d45a1637eeff96692c3fe567ad27aaa9135.jpeg",
    "https://cdn.faire.com/fastly/f66571e3f1238aaf2215603d43e35e8f30559ec1a52a015d0c29c43333e5d6dd.jpeg",
    "https://cdn.faire.com/fastly/efc2736cf6fa6c7a233df18f7ed522d046e93a5ea130d952ea0baf9f632a217d.jpeg",
    "https://cdn.faire.com/fastly/8b691a9821bdcdecb2e59fba8b4b47f4270729c5581fdedd5d63ef9df1a0ef08.jpeg",
  ],
  priceDollars: 38.58,
  description:
    "6x2mm  Smooth Natural Rondelle Beads For Jewelry Making,Available in 3 Different Colors, #01 Orange,#02 Picture Jasper,#03 Unakaite, RET26-RET15-RET13\nListing is for one single strand\n\nMeasurement: 6 x 2mm\nShape: Rondelle\nHole: 1mm\nLength of strand: 15.25 inches\n\n\nShip From Los Angeles",
  tags: [],
  msrpDollars: 77.16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:58.212Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
